import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FiShoppingBag, FiX } from "react-icons/fi";

const ApprovalModal = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const hasBeenDismissed = localStorage.getItem("approvalModalDismissed");
    if (!hasBeenDismissed) {
      setShow(true);
    }
  }, []);

  const handleClose = () => {
    setShow(false);
    localStorage.setItem("approvalModalDismissed", "true");
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm animate-fade-in" />
      
      {/* Modal Card */}
      <div className="relative bg-white w-full max-w-lg rounded-[48px] overflow-hidden shadow-2xl animate-zoom-in text-center p-12">
        <button 
          onClick={handleClose}
          className="absolute top-8 right-8 w-12 h-12 rounded-full bg-theme-bg text-theme-muted flex items-center justify-center hover:bg-gray-100 transition-all border border-component-border"
        >
          <FiX size={24} />
        </button>

        <div className="flex flex-col items-center space-y-8">
          <div className="w-24 h-24 bg-chafadi-primary text-white rounded-[32px] flex items-center justify-center shadow-2xl shadow-orange-500/20 rotate-3">
            <FiShoppingBag size={48} />
          </div>

          <div className="space-y-4">
            <h2 className="text-4xl font-black text-theme-text font-display tracking-tight">
              {t("approvalBanner.title")}
            </h2>
            <p className="text-theme-muted font-medium text-lg leading-relaxed max-w-sm mx-auto">
              {t("approvalBanner.message")}
            </p>
          </div>

          <button 
            onClick={handleClose}
            className="w-full h-16 bg-theme-text text-white font-black rounded-full text-sm uppercase tracking-[0.2em] shadow-xl hover:bg-black transition-all pt-1"
          >
            Acknowledge
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApprovalModal;
